// extracted by mini-css-extract-plugin
export default {"headingContainer":"Heading_headingContainer__UqW-O","heading":"Heading_heading__Ir4D0","text":"Heading_text__miCWr","tagline":"Heading_tagline__1FfHM"};